import React from "react";

import { Intro } from "components/commons";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import useDataTable from "hooks/useDataTable";
import locale from "localization";

import { mapFilterToRequest, mapDataToList } from "./competitor-list.mapper";
import { columns } from "./competitor-list-column";
import { initialFilterState } from "./competitor-list-filter.state";
import { useModal, useRouter } from "hooks";
import CompetitorListFilter from "./competitor-list-filter";
import { getCompetitors } from "apis/competitor.api";
import { Path } from "enums";
import { ConfirmModal } from "components/modals";
import { generateReport } from "apis/generate-report.api";
import useExport from "hooks/useExport";

const CompetitorListModule = () => {
  const confirmModal = useModal();

  const { history } = useRouter();

  const handleUpdateCompetitor = (params) => {
    history.push(Path.EditCompetitor, {
      brandId: params.brandId,
      updatedAt: params.updatedAt,
    });
  };

  const handleViewCompetitor = (params) => {
    history.push(Path.ViewCompetitor, {
      brandId: params.brandId,
      updatedAt: params.updatedAt,
    });
  };

  const { filter, search, table } = useDataTable({
    api: {
      api: getCompetitors,
      // params: {
      //   portal: Portal.PRICETRACQ,
      //   profileType: ProfileType.PT,
      // },
      mapper: (param) => {
        return param;
      },
    },
    filter: { initialState: initialFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "brands",
      mapper: (brands) =>
        mapDataToList({
          brands,
          handleUpdateCompetitor,
          handleViewCompetitor,
        }),
      columns,
    },
  });

  const exportReport = useExport({
    api: generateReport,
    reportType: "brand",
    mappedFilterState: { ...filter?.mappedFilterState, searchKey: search?.searchKey },
  });

  delete table.result.count;
  return (
    <>
      <ConfirmModal
        {...exportReport.downloadProgressModal}
        title="Your download is in progress"
        content="Please wait while we generate your report"
        secondary={{ text: "Got it" }}
      />
      <ConfirmModal {...confirmModal} />
      <Intro
        title={locale.competitorList}
        subtitle={locale.monitorCompetitorStationsToPricetracqPortal}
        actionText={locale.addNewCompetitorBrand}
        actionOnClick={() => history.push(Path.AddCompetitor)}
      />
      <CompetitorListFilter {...filter} {...search} {...exportReport} />
      <DataTableV2 {...table} paginationV2 />
    </>
  );
};

export default CompetitorListModule;
